<template>
  <md-field :class="{ 'md-invalid': hasErrors, 'md-read-only': blReadOnly }" class="mkt-date-time-input">
		<mkt-label
			v-if="txLabel"
			class="mkt-field__label"
			:txLabel="txLabel"
			:ob-label-icon="obLabelIcon"
			:bl-required="blRequired"
		></mkt-label>
		<md-input
			class="mkt-date-time-input__date"
			@keyup.esc="modelDate = null"
			:placeholder="txPlaceholder"
			:disabled="blDisabled || blReadOnly"
			type="datetime-local"
			:required="blRequired"
			:id="txId"
			v-model="modelDateTime"
			@blur="validateField"
		></md-input>
		<span class="md-error" v-if="hasErrors">{{formValidationError || 'Campo obrigatório'}}</span>
  </md-field>
</template>

<script>
import PropConfig from 'pojos/PropConfig'
import InputType from 'domains/InputType'

export default {
	name: 'mkt-date-time-input',
	props: {
		txLabel: new PropConfig({ type: String }),
		txPlaceholder: new PropConfig({ type: String, valueDefault: ' ' }),
		txMask: new PropConfig({ type: String }),
		blRequired: new PropConfig({ type: Boolean, valueDefault: false }),
		blDisabled: new PropConfig({ type: Boolean }),
		blReadOnly: new PropConfig({ type: Boolean, required: false, valueDefault: false }),
		nrMaxlength: new PropConfig({ type: Number, valueDefault: 16 }),
		txId: new PropConfig({ type: String, required: false }),
		obLabelIcon: new PropConfig({ type: Object, required: false }),
		value: new PropConfig({ required: false })
	},
	data() {
		return {
			tpInputType: InputType.NUMBER,
			hasErrors: false,
			formValidationError: ''
		}
	},
	computed: {
		modelDateTime: {
			get() {
				return this.value
			},
			set(val) {
				this.$emit('input', val)
			}
		}
	},
	methods: {
		validateField() {
			if (!this.value) {
				this.modelDateTime = null
			}

			this.$emit('blur')
			if (this.blRequired) {
				this.$nextTick(() => {
					this.hasErrors = !this.value
				})
			} else {
				this.hasErrors = false
			}
		}
	}
}
</script>

<style src="./mktDateTimeInput.scss" lang="scss">
</style>
